import React,{useEffect,useMemo,useState} from 'react';
import API from '../utils/api';

const STATUS={pending:'待经理确认',open:'投票中',ended:'已截止',rejected:'已退回'};
const fmt=value=>value?new Date(value).toLocaleString('zh-CN',{hour12:false}):'-';

export default function CommunityManage({user}){
  const canConfirm=['admin','manager','general_manager'].includes(user.role);
  const [tab,setTab]=useState('notices');
  const [data,setData]=useState({notices:[],votes:[]});
  const [loading,setLoading]=useState(false);
  const [notice,setNotice]=useState({title:'',content:''});
  const [noticeImage,setNoticeImage]=useState(null);
  const [noticeImagePreview,setNoticeImagePreview]=useState(null);
  const tomorrow=useMemo(()=>{const d=new Date(Date.now()+86400000);d.setSeconds(0,0);return new Date(d.getTime()-d.getTimezoneOffset()*60000).toISOString().slice(0,16);},[]);
  const [vote,setVote]=useState({title:'',description:'',options:'同意\n不同意\n弃权',deadline_local:tomorrow});
  const run=async fn=>{setLoading(true);try{await fn();}catch(e){alert(e.response?.data?.message||'操作失败');}finally{setLoading(false);}};
  const load=()=>run(async()=>{const r=await API.get('/community/manage');setData(r.data);});
  useEffect(()=>{load();const timer=setInterval(()=>API.get('/community/manage').then(r=>setData(r.data)).catch(()=>{}),30000);return()=>clearInterval(timer);},[]);
  const publish=()=>run(async()=>{
    const fd=new FormData();
    fd.append('title',notice.title);
    fd.append('content',notice.content);
    if(noticeImage) fd.append('image',noticeImage);

    await API.post(
      '/community/notices',
      fd,
      {headers:{'Content-Type':'multipart/form-data'}}
    );

    alert('物业通告已发布');

    setNotice({title:'',content:''});
    setNoticeImage(null);

    if(noticeImagePreview){
      URL.revokeObjectURL(noticeImagePreview);
    }
    setNoticeImagePreview(null);

    const r=await API.get('/community/manage');
    setData(r.data);
  });
  const createVote=()=>run(async()=>{const options=vote.options.split(/\n/).map(x=>x.trim()).filter(Boolean);const deadline_ts=new Date(vote.deadline_local).getTime();await API.post('/community/votes',{title:vote.title,description:vote.description,options,deadline_ts});alert('方案已提交经理确认');setVote({...vote,title:'',description:''});const r=await API.get('/community/manage');setData(r.data);});
  const confirm=id=>{if(!window.confirm('确认后将立即显示到业主投票页面，确定发布吗？'))return;run(async()=>{await API.post(`/community/votes/${id}/confirm`);alert('已确认发布');const r=await API.get('/community/manage');setData(r.data);});};
  const reject=id=>{const reason=window.prompt('请输入退回原因');if(!reason?.trim())return;run(async()=>{await API.post(`/community/votes/${id}/reject`,{reason});alert('已退回');const r=await API.get('/community/manage');setData(r.data);});};
  const hideNotice=id=>{if(!window.confirm('确定撤下这条物业通告吗？'))return;run(async()=>{await API.post(`/community/notices/${id}/hide`);const r=await API.get('/community/manage');setData(r.data);});};
  return <div style={s.page}>
    <header style={s.header}><div style={s.title}>📣 物业通告与业主投票</div><div style={s.sub}>管家录入 · 经理确认 · 一户一票 · 截止后公开结果</div></header>
    <div style={s.tabs}>{[['notices','物业通告'],['newVote','录入投票方案'],['votes','投票管理']].map(([k,l])=><button key={k} style={{...s.tab,...(tab===k?s.tabOn:{})}} onClick={()=>setTab(k)}>{l}</button>)}</div>
    {loading&&<div style={s.loading}>处理中...</div>}
    <main style={s.body}>
      {tab==='notices'&&<>
        <section style={s.panel}>
          <h3 style={s.h3}>发布物业广播通告</h3>

          <input
            style={s.input}
            value={notice.title}
            onChange={e=>setNotice({...notice,title:e.target.value})}
            placeholder="通告标题"
          />

          <textarea
            style={s.textarea}
            value={notice.content}
            onChange={e=>setNotice({...notice,content:e.target.value})}
            placeholder="通告内容"
          />

          <div style={{
            fontSize:13,
            fontWeight:700,
            margin:'12px 0 7px'
          }}>
            公告配图（可选）
          </div>

          <label style={{
            display:'flex',
            alignItems:'center',
            justifyContent:'center',
            minHeight:86,
            border:'1.5px dashed #aebccc',
            borderRadius:10,
            background:'#f8fafc',
            color:'#55718d',
            cursor:'pointer',
            padding:10,
            marginBottom:10
          }}>
            📷 拍照或从相册选择图片

            <input
              type="file"
              accept="image/*"
              style={{display:'none'}}
              onChange={e=>{
                const f=e.target.files?.[0];
                if(!f)return;

                if(f.size>6*1024*1024){
                  alert('图片不能超过6MB');
                  e.target.value='';
                  return;
                }

                if(noticeImagePreview){
                  URL.revokeObjectURL(noticeImagePreview);
                }

                setNoticeImage(f);
                setNoticeImagePreview(URL.createObjectURL(f));
              }}
            />
          </label>

          {noticeImagePreview?
            <div style={{marginBottom:12}}>
              <img
                src={noticeImagePreview}
                alt="公告预览"
                style={{
                  display:'block',
                  width:'100%',
                  maxHeight:300,
                  objectFit:'contain',
                  borderRadius:10,
                  background:'#f5f5f5'
                }}
              />

              <button
                type="button"
                onClick={()=>{
                  if(noticeImagePreview){
                    URL.revokeObjectURL(noticeImagePreview);
                  }
                  setNoticeImage(null);
                  setNoticeImagePreview(null);
                }}
                style={{
                  marginTop:7,
                  border:0,
                  background:'transparent',
                  color:'#c33'
                }}
              >
                删除配图
              </button>
            </div>
          :null}

          <button style={s.primary} onClick={publish}>
            立即发布到业主首页
          </button>
        </section>
        {data.notices.map(n=><section style={s.card} key={n.id}>
          <div style={s.row}>
            <b>{n.title}</b>
            <span style={n.status==='published'?s.published:s.hidden}>
              {n.status==='published'?'已发布':'已撤下'}
            </span>
          </div>

          {n.image_path?
            <img
              src={'/uploads/'+encodeURIComponent(String(n.image_path).split(/[\\/]/).pop())}
              alt="公告配图"
              style={{
                width:'100%',
                maxHeight:260,
                objectFit:'contain',
                borderRadius:9,
                margin:'10px 0',
                background:'#f5f5f5'
              }}
            />
          :null}

          <div style={s.content}>{n.content}</div>

          <div style={s.meta}>
            {n.created_name||'-'} · {fmt(n.created_at)}
          </div>

          {canConfirm&&n.status==='published'&&
            <button
              style={s.danger}
              onClick={()=>hideNotice(n.id)}
            >
              撤下通告
            </button>
          }
        </section>)}
      </>}
      {tab==='newVote'&&<section style={s.panel}><h3 style={s.h3}>录入业主投票方案</h3><div style={s.tip}>管家提交后不会立即显示给业主，必须由经理确认发布。</div><input style={s.input} value={vote.title} onChange={e=>setVote({...vote,title:e.target.value})} placeholder="投票标题"/><textarea style={s.textarea} value={vote.description} onChange={e=>setVote({...vote,description:e.target.value})} placeholder="方案详细说明"/><label style={s.label}>投票选项（每行一个）<textarea style={s.options} value={vote.options} onChange={e=>setVote({...vote,options:e.target.value})}/></label><label style={s.label}>截止日期和时间<input style={s.input} type="datetime-local" value={vote.deadline_local} onChange={e=>setVote({...vote,deadline_local:e.target.value})}/></label><button style={s.primary} onClick={createVote}>提交经理确认</button></section>}
      {tab==='votes'&&<>{data.votes.length?data.votes.map(v=><section style={s.card} key={v.id}><div style={s.row}><b>{v.title}</b><span style={s.badge}>{STATUS[v.effective_status]||v.effective_status}</span></div><div style={s.content}>{v.description}</div><div style={s.optionsList}>{v.options.map((o,i)=><div key={i}>{i+1}. {o}</div>)}</div><div style={s.meta}>录入：{v.created_name||'-'} · 截止：{fmt(Number(v.deadline_ts))} · 已参与{v.total_ballots}户</div>{v.confirmed_name&&<div style={s.meta}>确认经理：{v.confirmed_name}</div>}{v.reject_reason&&<div style={s.rejectReason}>退回原因：{v.reject_reason}</div>}{v.results&&<Result results={v.results} total={v.total_ballots}/>} {canConfirm&&v.status==='pending'&&<div style={s.actions}><button style={s.approve} onClick={()=>confirm(v.id)}>确认并发布</button><button style={s.danger} onClick={()=>reject(v.id)}>退回修改</button></div>}</section>):<div style={s.empty}>暂无投票方案</div>}</>}
    </main>
  </div>;
}

function Result({results,total}){return <div style={s.result}><b>投票结果（共{total}票）</b>{results.map(r=><div key={r.index} style={s.resultItem}><div style={s.resultLine}><span>{r.label}</span><b>{r.count}票 · {r.percentage}%</b></div><div style={s.track}><div style={{...s.fill,width:`${r.percentage}%`}}/></div></div>)}</div>}

const s={page:{minHeight:'100vh',background:'#f3f6fa',paddingBottom:80},header:{background:'linear-gradient(135deg,#173f73,#2d7dd2)',color:'#fff',padding:'20px 16px'},title:{fontSize:22,fontWeight:800},sub:{fontSize:13,opacity:.85,marginTop:5},tabs:{display:'flex',gap:7,overflowX:'auto',padding:10,background:'#fff',position:'sticky',top:0,zIndex:5},tab:{border:'none',borderRadius:17,padding:'8px 14px',whiteSpace:'nowrap',background:'#edf1f6',color:'#4d5c70'},tabOn:{background:'#1a5da8',color:'#fff'},body:{maxWidth:900,margin:'0 auto',padding:14},loading:{position:'fixed',right:12,top:12,zIndex:10,background:'#222',color:'#fff',padding:'6px 11px',borderRadius:13,fontSize:12},panel:{background:'#fff',borderRadius:13,padding:14,marginBottom:14,boxShadow:'0 2px 9px #0000000d'},card:{background:'#fff',borderRadius:13,padding:14,marginBottom:10,boxShadow:'0 2px 9px #0000000d'},h3:{margin:'0 0 12px'},input:{width:'100%',boxSizing:'border-box',border:'1px solid #d6dee9',borderRadius:8,padding:'10px 11px',fontSize:14,marginBottom:9},textarea:{width:'100%',boxSizing:'border-box',minHeight:120,border:'1px solid #d6dee9',borderRadius:8,padding:11,fontSize:14,marginBottom:9},options:{width:'100%',boxSizing:'border-box',minHeight:100,border:'1px solid #d6dee9',borderRadius:8,padding:11,fontSize:14,margin:'6px 0 9px'},label:{display:'block',fontSize:13,color:'#556274'},primary:{border:'none',borderRadius:9,background:'#1a5da8',color:'#fff',fontWeight:700,padding:'10px 15px'},row:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',gap:8},published:{fontSize:11,color:'#389e0d',background:'#f0fff0',padding:'4px 8px',borderRadius:10},hidden:{fontSize:11,color:'#999',background:'#eee',padding:'4px 8px',borderRadius:10},badge:{fontSize:11,color:'#1a5da8',background:'#eaf3ff',padding:'4px 8px',borderRadius:10,whiteSpace:'nowrap'},content:{whiteSpace:'pre-wrap',lineHeight:1.7,fontSize:14,color:'#333',marginTop:10},meta:{fontSize:12,color:'#888',marginTop:9},tip:{background:'#fffbe6',color:'#8c6d1f',borderRadius:8,padding:9,fontSize:12,marginBottom:10},optionsList:{background:'#f6f8fb',borderRadius:8,padding:10,lineHeight:1.8,fontSize:13,marginTop:9},actions:{display:'flex',gap:9,justifyContent:'flex-end',marginTop:12},approve:{border:'none',borderRadius:8,background:'#389e0d',color:'#fff',padding:'8px 12px'},danger:{border:'none',borderRadius:8,background:'#fff1f0',color:'#cf1322',padding:'8px 12px',marginTop:10},rejectReason:{background:'#fff1f0',color:'#cf1322',padding:8,borderRadius:7,fontSize:12,marginTop:8},result:{marginTop:12,borderTop:'1px solid #eee',paddingTop:11},resultItem:{marginTop:9},resultLine:{display:'flex',justifyContent:'space-between',fontSize:12,gap:10},track:{height:7,background:'#e8edf3',borderRadius:4,marginTop:5,overflow:'hidden'},fill:{height:'100%',background:'#2d7dd2',borderRadius:4},empty:{textAlign:'center',color:'#999',padding:35}};
